import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  Inject,
} from '@angular/core';
import { NewPageService } from '../../../new-page.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-documents',
  templateUrl: './documents.component.html',
  styleUrls: ['./documents.component.scss'],
  standalone: false,
})
export class DocumentsComponent {
  // @Input() slug: string = '';
  // @Input() disclosure: any = {};
  @Output() close = new EventEmitter<void>();
  documentList: any[] = [];
  isLoading: boolean = true;
  slug: string = '';
  disclosure: any = {};

  constructor(
    private apiService: NewPageService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<DocumentsComponent>
  ) {}

  ngOnInit(): void {
    this.documentList = this.data.disclosure;
    this.slug = this.data.slug;
    this.isLoading = false;
  }

  closeModal() {
    this.close.emit();
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }
}
